import { ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import Cookies from "js-cookie";

import PropTypes from "prop-types";
import { LogoutIcon } from "src/components/icons/PersonIcons";

export default function GlobalDrawer_LogoutListItem(props) {
  const fontSize = props.fontSize || "26px";
  const logoutClick = async () => {
    localStorage.clear();
    Cookies.remove("token");
    console.log("logging out");
    //await auth.signOut();
    window.location = "/";
  };
  return (
    <ListItem disablePadding>
      <ListItemButton onClick={logoutClick}>
        <ListItemIcon>
          <LogoutIcon style={{ fontSize: fontSize }} />
        </ListItemIcon>
        <ListItemText primary="Kirjaudu ulos" />
      </ListItemButton>
    </ListItem>
  );
}

GlobalDrawer_LogoutListItem.propTypes = {
  fontSize: PropTypes.string,
};
